import { BrowserRouter as Router } from 'react-router-dom';
import HomePage from './pages/HomePage';
import './App.css';

function App() {
  return (
    <Router>
      <HomePage />
    </Router>
  );
}

export default App;
